import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";

export const giata: string = 'GIATA';

export const WORDING: ILabels = {
    generateQuotation: Yii.t('wui-shared-js', 'Génération de la cotation ...'),
    roomsLoading: Yii.t('wui-shared-js', 'Chargement des chambres en cours ...'),
    close: Yii.t('wui-shared-js', 'Fermer'),
    hotelsLoading: Yii.t('wui-shared-js', 'Recherche des hôtels en cours ...'),
    showMap: Yii.t('wui-shared-js', 'Voir sur la carte'),
    matchingHotels: Yii.t('wui-shared-js', 'hôtels correspondant à la recherche')
};
